export default __webpack_public_path__ + "static/hero-image-0028e34db582c8e95c8091b3f6d36daa.png";